<div class="logo-heading-container">
    <img src="../../../../assets/imgs/logo/logo.png" alt="locked-img" class="logo-heading-img">
    <div>
        <label class="logo-heading-description-title">{{titleDescription | translate}}</label>
    </div>
</div>